import { optimove } from 'js/analytics/adapters'
export const trackViewFaq = () => {
  optimove.track('view_faq')
}
